import type { ReactNode } from 'react';

export const symbol_lock_clock: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M350-634h260v-93q0-57-37.5-95T480-860q-55 0-92.5 38T350-727v93ZM220-80q-23 0-41.5-18.5T160-140v-434q0-23 18.5-41.5T220-634h70v-93q0-81 55-137t135-56q80 0 135 56t55 137v93h70q23 0 41.5 18.5T800-574v49q0 14.5-9.32 21.75t-20.5 7.25q-11.18 0-20.68-7.5T740-526v-48H220v434h298q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q530.75-80 518-80H220Zm397-23q-57-57-57-136t57-136q57-57 136-57t136 57q57 57 57 136t-57 136q-57 57-136 57t-136-57Zm153-138v-103.04q0-8.96-6-14.96t-15-6q-9 0-15 6t-6 14.97V-242q0 6.07 2.5 11.76 2.5 5.69 7.5 10.24l76 70q5 5 13 4.5t13-5.5q6-6 5.5-14t-6.5-13l-69-63ZM220-574v434-434Z"
		/>
	</svg>
);
